import { Base } from "ui/Scripts/source/framework/base";
import { IdTitle, IIdTitle } from "ui/Scripts/source/models/common/idTitle";
import { IIdColorTitle, IdColorTitle } from "ui/Scripts/source/models/common/idColorTitle";
import { IdTitleNode, IIdTitleNode } from "ui/Scripts/source/models/common/idTitleNode";
import { INumberTitle, NumberTitle } from "ui/Scripts/source/models/common/numberTitle";
import { CodeTitle, ICodeTitle } from "../common/codeTitle";
import { IPagePanel } from "../common/pagePanel";
import { RecordPagePanel } from "../record/recordPagePanel";
import { ISavedPrint, SavedPrint } from "../common/savedPrint";

export interface IEventPageData {
    canEditModuleProperties: boolean;
    canEditAllModuleProperties: boolean;
    hasExplicitEventPartners: boolean;
    panels: IPagePanel[];
    units: IIdTitleNode[];
    states: INumberTitle[];
    urgencyClasses: IIdColorTitle[];
    partners: IIdTitle[];
    creators: ICodeTitle[];
    handlers: ICodeTitle[];
    observers: ICodeTitle[];
    eventTypes: IIdTitleNode[];
    eventTypeBs: IIdTitleNode[];
    eventTypeCs: IIdTitleNode[];
    userPrints: ISavedPrint[];
    printableFields: IIdTitleNode[];
}

export class EventPageData implements IEventPageData {
    canEditModuleProperties: boolean;
    canEditAllModuleProperties: boolean;
    hasExplicitEventPartners: boolean;
    panels: RecordPagePanel[];
    units: IdTitleNode[];
    states: NumberTitle[];
    urgencyClasses: IdColorTitle[];
    partners: IdTitle[];
    creators: CodeTitle[];
    handlers: CodeTitle[];
    observers: CodeTitle[];
    eventTypes: IdTitleNode[];
    eventTypeBs: IdTitleNode[];
    eventTypeCs: IdTitleNode[];
    userPrints: SavedPrint[];
    printableFields: IdTitleNode[];

    constructor();
    constructor(obj: IEventPageData);
    constructor(obj?: any) {
        this.canEditModuleProperties = obj && obj.canEditModuleProperties || false;
        this.canEditAllModuleProperties = obj && obj.canEditAllModuleProperties || false;
        this.hasExplicitEventPartners = obj && obj.hasExplicitEventPartners || false;
        this.panels = Base.getTypedArray(obj ? obj.panels : null, RecordPagePanel);
        this.units = Base.getTypedArray(obj ? obj.units : null, IdTitleNode);
        this.states = Base.getTypedArray(obj ? obj.states : null, NumberTitle);
        this.urgencyClasses = Base.getTypedArray(obj ? obj.urgencyClasses : null, IdColorTitle);
        this.partners = Base.getTypedArray(obj ? obj.partners : null, IdTitle);
        this.creators = Base.getTypedArray(obj ? obj.creators : null, CodeTitle);
        this.handlers = Base.getTypedArray(obj ? obj.handlers : null, CodeTitle);
        this.observers = Base.getTypedArray(obj ? obj.observers : null, CodeTitle);
        this.eventTypes = Base.getTypedArray(obj ? obj.eventTypes : null, IdTitleNode);
        this.eventTypeBs = Base.getTypedArray(obj ? obj.eventTypeBs : null, IdTitleNode);
        this.eventTypeCs = Base.getTypedArray(obj ? obj.eventTypeCs : null, IdTitleNode);
        this.userPrints = SavedPrint.sortSavedPrints(Base.getTypedArray(obj ? obj.userPrints : null, SavedPrint));
        this.printableFields = Base.getTypedArray(obj ? obj.printableFields : null, IdTitleNode);
    }
}
